export default "__VITE_ASSET__B2YrP9RE__"